import * as actions from "./actions";
import { createPathfinder } from "./pathfinder";
import Directions from "./directions";
import Random from "rung/src/random";

const rng = new Random(Math.random);

function scatterAndFlee(entity, chaser, stage) {
  console.log(`scatterAndFlee: ${entity.name} is fleeing`);

  let x = Math.sign(chaser.x - entity.x);
  let y = Math.sign(chaser.y - entity.y);

  if (stage.canCharacterMoveTo(x, y) && stage.isUnoccupied(x, y)) {
    stage.moveEntityTo(entity, x, y);
  }
}

function walkTo(entity, target, stage) {
  if (stage.canCharacterMoveTo(target.x, target.y) && stage.isUnoccupied(target.x, target.y)) {
    stage.moveEntityTo(entity, target.x, target.y);
  }
}

function drunkenWalk(entity, stage) {
  let direction = Directions.CARDINAL[rng.integer(4)];
  actions.walkAction(entity, direction, stage);
}

function meleeCharge(entity, target, stage) {
  //console.log(`meleeCharge: ${entity.name} is charging`);

  const adjacentNodes = (x, y) => stage.adjacentPoints(x, y);
  const costHeuristic = (from, to) => (
    Math.abs(from.x - to.x) + Math.abs(from.y - to.y) * 1.01
  );
  const traversalCost = (x, y) => stage.movementCost(x, y);
  const isTraversable = (x, y) => stage.canMoveTo(x, y);

  const search = createPathfinder(
    adjacentNodes,
    costHeuristic,
    traversalCost,
    isTraversable
  );

  const path = search(
    { x: entity.x, y: entity.y },
    { x: target.x, y: target.y }
  );

  const next = path[0];

  // if (stage.isUnoccupied(next.x, next.y)) {
  //   stage.moveEntityTo(entity, next.x, next.y);
  // } else {
  //   const entities = stage.entitiesAt(next.x, next.y);
  //   const _target = entities.find(e => e === target);
  //   if (_target) _target.bumpFrom(entity, stage);
  // }
  actions.walkAction(entity, { x: next.x - entity.x, y: next.y - entity.y}, stage);
}

function meleeAttack(entity, target, stage) {
  entity.combat.attackBonus
  target.combat.defenceScore
}

function rangedAttack(entity, target, stage) {

}

function yeet(entity, target, stage) {
  console.log(`${entity.name} yeets (something?) at ${target.name}`);

  if (target.isVulnerable()) {
    target.hit(5);
  }
}

class BehaviourState {
  #name;
  get name() {
    if (!this.#name) {
      this.#name = this.constructor.name.replace(/State$/, "");
    }
    return this.#name;
  }

  enter() {
    console.log(`enter ${this.name}`)
  }

  execute(entity, stage) {
    return;
  }

  leave() {
    console.log(`leave ${this.name}`)
  }
}
  
class IdlingState extends BehaviourState {
  execute(entity, stage) {
    console.log("IdlingState");
    entity.sense.increaseFatigue();
    entity.sense.increaseHunger();

    if (entity.sense.isTired()) {
      entity.sense.tired();
    } else if (entity.sense.isHungry()) {
      entity.sense.hungry();
    }
  }
}

class RestingState extends BehaviourState {
  execute(entity, stage) {
    console.log("RestingState");
    entity.sense.decreaseFatigue(2);

    if (entity.sense.isRested()) {
      entity.sense.wakeup();
    }
  }
}

class ForagingState extends BehaviourState {
  execute(entity, stage) {
    console.log("ForagingState");
    entity.sense.increaseFatigue(3);
    drunkenWalk(entity, stage);
    entity.sense.decreaseHunger(Math.round(Math.random() * 2));

    if (entity.sense.isTired()) {
      entity.sense.tired();
    } else if (entity.sense.isSated()) {
      entity.sense.sated();
    }
  }
}

class TendingState extends BehaviourState {
  execute(entity, stage) {
    console.log("TendingState");

    let direction = Directions.CARDINAL[rng.integer(4)];
    
    if (stage.isOf(entity.x + direction.x, entity.y + direction.y, "Garden")) {
      actions.walkAction(entity, direction, stage);
    }
  }
}

class SeekingState extends BehaviourState {
  enter(context) {
    const adjacentNodes = (x, y) => stage.adjacentPoints(x, y);
    const costHeuristic = (from, to) => (
      Math.abs(from.x - to.x) + Math.abs(from.y - to.y) * 1.01
    );
    const traversalCost = (x, y) => stage.movementCost(x, y);
    const isTraversable = (x, y) => stage.canMoveTo(x, y);

    const search = createPathfinder(
      adjacentNodes,
      costHeuristic,
      traversalCost,
      isTraversable
    );

    const path = search(
      { x: entity.x, y: entity.y },
      { x: target.x, y: target.y }
    );

    const next = path[0];
  }
}

const behaviourStates = {
  RestingState,
  IdlingState,
  ForagingState,
  TendingState,
  SeekingState
}

class Behaviour {
  constructor({ initial, states }) {
    const availableStates = Object.keys(states).reduce((table, stateLabel) => {
      table[stateLabel] = new behaviourStates[`${stateLabel}State`]();
      return table;
    }, {});

    this.currentState = availableStates[initial];
    this.previousState = null;
    this.transitions = {}
    
    for (const stateLabel of Object.keys(states)) {
      this.transitions[stateLabel] = Object.keys(states[stateLabel]).reduce((table, transitionLabel) => {
        table[transitionLabel] = availableStates[states[stateLabel][transitionLabel]];
        return table;
      }, {});
    }
  }

  canTransition(label) {
    return this.transitions[this.currentState.name][label] !== undefined;
  }

  transition(label, skip=false) {
    const nextState = this.transitions[this.currentState.name][label];

    if (nextState) {
      this.currentState.leave();
      this.previousState = this.currentState;
      this.currentState = nextState;
      this.currentState.enter();
    } else {
      if (!skip) {
        throw new Error(`Undefined behaviour for transition: ${label}`);
      }
    }
  }

  execute(entity, stage) {
    this.currentState.execute(entity, stage);
  }
}

export default Behaviour;

export {
  yeet,
  walkTo,
  drunkenWalk,
  meleeCharge,
  scatterAndFlee
}
